export type SubmissionsTab = "all" | "files";

interface SubmissionsTabsProps {
  value: SubmissionsTab;
  onChange: (next: SubmissionsTab) => void;
  fileCount: number;
}

export function SubmissionsTabs({ value, onChange, fileCount }: SubmissionsTabsProps) {
  return (
    <div className="tabs" role="tablist">
      <button
        type="button"
        role="tab"
        aria-selected={value === "all"}
        className={`tabs__tab${value === "all" ? " tabs__tab--active" : ""}`}
        onClick={() => onChange("all")}
      >
        ทั้งหมด
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === "files"}
        className={`tabs__tab${value === "files" ? " tabs__tab--active" : ""}`}
        onClick={() => onChange("files")}
      >
        ไฟล์
        <span className="tabs__badge" aria-label={`${fileCount} files`}>
          {fileCount}
        </span>
      </button>
    </div>
  );
}
